import script from "./PopulationHighlight.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopulationHighlight.vue?vue&type=script&lang=ts&setup=true"

import "./PopulationHighlight.vue?vue&type=style&index=0&id=3abfc63e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3abfc63e"]])

export default __exports__